const React = require('react');

class Thermostat extends React.Component {
  getStyles() {
    // Determine if the thermostat is actively working to reach the target temperature.
    /* let dialColor = '#222';
     if (this.props.hvacMode === 'heating') {
       dialColor = '#E36304';
     } else if (this.props.hvacMode === 'cooling') {
       dialColor = '#007AF1';
     }
*/
    return {
      dial: {
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none'
      },
      circle: {
        fill: "transparent",
        WebkitTransition: 'fill 0.5s',
        transition: 'fill 0.5s'
      },
      target : {
        fill: 'white',
        textAnchor: 'middle',
        fontFamily: 'Helvetica, sans-serif',
        alignmentBaseline: 'central',
        fontSize: '100px',
        fontWeight: 'bold',
        visibility: this.props.away ? 'hidden' : 'visible'
      },
      ambient: {
        fill: 'white',
        textAnchor: 'middle',
        fontFamily: 'Helvetica, sans-serif',
        alignmentBaseline: 'central',
        fontSize: '22px',
        fontWeight: 'bold'
      },
      away: {
        fill: 'white',
        textAnchor: 'middle',
        fontFamily: 'Helvetica, sans-serif',
        alignmentBaseline: 'central',
        fontSize: '72px',
        fontWeight: 'bold',
        opacity: this.props.away ? '1' : '0',
        pointerEvents: 'none'
      },
      leaf: {
        fill: '#13EB13',
        opacity: this.props.leaf ? '1' : '0',
        visibility: this.props.away ? 'hidden' : 'visible',
        WebkitTransition: 'opacity 0.5s',
        transition: 'opacity 0.5s',
        pointerEvents: 'none'
      }
    };
  }

  roundToHalf(value) {
    var converted = parseFloat(value); // Make sure we have a number 
    let multiplier = 1;
    if (value < 0) {
      multiplier = -1
    }
    converted = Math.abs(converted)
    var decimal = (converted - parseInt(converted, 10));
    decimal = Math.round(decimal * 10);
    if (decimal === 5) {
      return (parseInt(converted, 10) + 0.5) * (multiplier);
    }
    if ((decimal < 3) || (decimal > 7)) {
      return Math.round(converted) * (multiplier);
    }
    else {
      return (parseInt(converted, 10) + 0.5) * (multiplier);
    }
  }

  pointsToPath(points) {
    return [points.map((point, iPoint) => [iPoint > 0 ? 'L' : 'M', point[0], ' ', point[1]].join('')).join(' '), 'Z'].join('');
  }

  rotatePoint(point, angle, origin) {
    const radians = angle * Math.PI / 180;
    const x = point[0] - origin[0];
    const y = point[1] - origin[1];
    const x1 = x * Math.cos(radians) - y * Math.sin(radians) + origin[0];
    const y1 = x * Math.sin(radians) + y * Math.cos(radians) + origin[1];
    return [x1, y1];
  }

  rotatePoints(points, angle, origin) {
    const _self = this;
    return points.map(point => _self.rotatePoint(point, angle, origin));
  }

  restrictToRange(val, min, max) {
    if (val < min) return min;
    if (val > max) return max;
    return val;
  }

  mapLeafPoint(point, scale) {
    return isNaN(point) ? point : point * scale;
  }

  render() {
    const _self = this;

    // Local variables used for rendering.
    const diameter = 400;
    const radius = diameter / 2;
    const ticksOuterRadius = diameter / 30;
    const ticksInnerRadius = diameter / 8;
    const tickDegrees = 300;
    const rangeValue = this.props.maxValue - this.props.minValue;

    // Determine the maximum and minimum values to display.
    let actualMinValue;
    let actualMaxValue;
    if (this.props.away) {
      actualMinValue = this.props.targetTemperature;
      actualMaxValue = actualMinValue;
    } else {
      actualMinValue = Math.min(this.props.targetTemperature, this.props.ambientTemperature);
      actualMaxValue = Math.max(this.props.targetTemperature, this.props.ambientTemperature);
    }
    const min = this.restrictToRange(Math.round((actualMinValue - this.props.minValue) / rangeValue * this.props.numTicks), 0, this.props.numTicks - 1);
    const max = this.restrictToRange(Math.round((actualMaxValue - this.props.minValue) / rangeValue * this.props.numTicks), 0, this.props.numTicks - 1);

    // Renders the degree ticks around the outside of the thermostat.
    const tickPoints = [[radius - 1, ticksOuterRadius], [radius + 1, ticksOuterRadius], [radius + 1, ticksInnerRadius], [radius - 1, ticksInnerRadius]];
    const tickPointsLarge = [[radius - 1.5, ticksOuterRadius], [radius + 1.5, ticksOuterRadius], [radius + 1.5, ticksInnerRadius + 20], [radius - 1.5, ticksInnerRadius + 20]];
    const theta = tickDegrees / this.props.numTicks;
    const offsetDegrees = 180 - (360 - tickDegrees) / 2;
    const tickArray = [];
    for (let iTick = 0; iTick < this.props.numTicks; iTick++) {
      const isLarge = iTick === min || iTick === max;
      const isActive = iTick >= min && iTick <= max;
      const tickElement = React.createElement('path', {
        key: ['tick-', iTick].join(''),
        d: this.pointsToPath(this.rotatePoints(isLarge ? tickPointsLarge : tickPoints, iTick * theta - offsetDegrees, [radius, radius])),
        style: {
          fill: isActive ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.4)'
        }
      });
      tickArray.push(tickElement);
    }

    // Determines the positioning of the leaf, should it be displayed.
    const leafScale = radius / 5 / 100;
    const leafDef = ['M', 3, 84, 'c', 24, 17, 51, 18, 73, -6, 'C', 100, 52, 100, 22, 100, 4, 'c', -13, 15, -37, 9, -70, 19, 'C', 4, 32, 0, 63, 0, 76, 'c', 6, -7, 18, -17, 33, -23, 24, -9, 34, -9, 48, -20, -9, 10, -20, 16, -43, 24, 'C', 22, 63, 8, 78, 3, 84, 'z'].map(point => _self.mapLeafPoint(point, leafScale)).join(' ');
    const translate = [radius - leafScale * 100 * 0.5, radius * 1.5];

    // Determines whether the ambient temperature label will be displayed
    // to the left or right of the tick range.
    const lblAmbientPosition = [radius, ticksOuterRadius - (ticksOuterRadius - ticksInnerRadius) / 2];
    const peggedValue = this.restrictToRange(this.props.targetTemperature, this.props.minValue, this.props.maxValue);
    let degs = tickDegrees * (peggedValue - this.props.minValue) / rangeValue - offsetDegrees;
    if (peggedValue > this.props.ambientTemperature) {
      degs += 8;
    } else {
      degs -= 8;
    }
    const ambientPosition = this.rotatePoint(lblAmbientPosition, degs, [radius, radius]);

    // The styles change based on state.
    const styles = this.getStyles();

    // Piece it all together to form the thermostat display.
    return React.createElement(
      'svg',
      { width: this.props.width, height: this.props.height, style: styles.dial,
        viewBox: ['0 0 ', diameter, ' ', diameter].join('')
      },
      React.createElement('circle', { cx: radius, cy: radius, r: radius, style: styles.circle }),
      React.createElement(
        'g',
        null,
        tickArray
      ),
      React.createElement(
        'text',
        { x: radius, y: radius, style: styles.target },
        (this.props.ambientTemperature)
      ),
      React.createElement(
        'text',
        { x: ambientPosition[0], y: ambientPosition[1], style: styles.ambient },
        (this.props.targetTemperature)
      ),
      React.createElement(
        'text',
        { x: radius, y: radius, style: styles.away },
        'Off'
      ),
      React.createElement('path', { d: leafDef, style: styles.leaf,
        transform: ['translate(', translate[0], ',', translate[1], ')'].join('')
      })
    );
  }
}

// Thermostat.propTypes = {
//   /* Height of the thermostat (ex: 50% or 400px) */
//   height: React.PropTypes.string,
//   /* Width of the thermostat (ex: 50% or 400px) */
//   width: React.PropTypes.string,
//   /* Total number of ticks that will be rendered on the thermostat wheel */
//   numTicks: React.PropTypes.number,
//   /* Lowest temperature able to be displayed on the thermostat */
//   minValue: React.PropTypes.number,
//   /* Highest temperature able to be displayed on the thermostat */
//   maxValue: React.PropTypes.number,
//   /* Indicates whether or not the thermostat is in "away mode" */
//   away: React.PropTypes.bool,
//   /* Indicates whether or not the thermostat is in "energy savings mode" */
//   leaf: React.PropTypes.bool,
//   /* Actual temperature detected by the thermostat */
//   targetTemperature: React.PropTypes.number,
//   /* Desired temperature that the thermostat attempts to reach */
//   ambientTemperature: React.PropTypes.number,
//   /* Current state of operations within the thermostat */
//   hvacMode: React.PropTypes.oneOf(['off', 'heating', 'cooling'])
// };

Thermostat.defaultProps = {
  height: '98%',
  width: '98%',
  numTicks: 100,
  minValue: 50,
  maxValue: 85,
  away: false,
  leaf: false,
  targetTemperature: 74,
  ambientTemperature: 68,
  hvacMode: 'off'
};

export default Thermostat;
